<!-- PAGE TITLE================================================== -->

<section class="bg-light-red page-title-section top-position1 bg-img cover-background left-overlay-secondary">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <div class="position-relative">
                        <h1>How it works</h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- How this therapy works============= -->

<!-- <section class="section-padding bg-img cover-background bg-secondary parallax" data-overlay-dark="0"
    style="background-image: url(/assets/images/bg/bg1.jpg)">
    <div class="container">
        <div class="row">
            <div class="col-lg-7 col-xl-6 col-xxl-5 wow fadeInUp" data-wow-delay="100ms">
                <div class="working-section">
                    <div class="section-title">
                        <h2 class="mb-2">How this therapy works</h2>
                    </div>
                    <p class="mb-2">
                        It works by bypassing the digestive system and delivering
                        nutrients directly into the bloodstream, allowing for rapid
                        absorption and utilization by the body. This method ensures
                        that nutrients are immediately available for cellular
                        function, which can be beneficial for hydration, immune
                        support, energy, and overall wellness.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section> -->

<!-- How this therapy works -->
@if (items().length) {
  <section class="section-padding bg-img cover-background bg-secondary parallax" data-overlay-dark="0"
      [style.background-image]="'url(' + imgUrl(items()[0].ImagePath) + ')'">
      <div class="container">
          <div class="row">
              <div class="col-lg-7 col-xl-6 col-xxl-5 wow fadeInUp" data-wow-delay="100ms">

                  @for (a of items(); track a.ID; let last = $last) {
                    <div class="working-section" [class.mb-4]="!last">
                        <div class="section-title">
                            <h2 class="mb-2">{{ a.Title }}</h2>
                        </div>
                        <div class="how-desc" [innerHTML]="a.Description"></div>
                    </div>
                  }

              </div>
          </div>
      </div>
  </section>
}

@if (!loading() && !error() && !items().length) {
  <p class="text-center my-5">No content available.</p>
}
@if (error() && !items().length) {
  <p class="text-center my-5">Unable to load content right now.</p>
}

<!-- How this therapy works end============= -->